import { ReweighError } from '@shared/classes/error/reweigh-error';

export class IllegalArgumentError extends ReweighError {
  constructor(aMessage: string, aCause?: any) {
    super(aMessage, aCause);
  }
}
